import { EUserRole } from '../types/user';
import { dateRangeParams, queryString, request } from './http';

export type EAuditEntity =
	| 'DEPARTMENT'
	| 'ACADEMY'
	| 'SUBJECT'
	| 'COURSE'
	| 'ENROLLMENT'
	| 'RESOURCE'
	| 'ACCOUNT'
	| 'EVENT'
	| 'ANNOUNCEMENT';

export const AUDIT_ENTITY_LABELS: Record<EAuditEntity, string> = {
	DEPARTMENT: 'Departamentos',
	ACADEMY: 'Academias',
	SUBJECT: 'Materias',
	COURSE: 'Cursos',
	ENROLLMENT: 'Inscripciones',
	RESOURCE: 'Recursos',
	ACCOUNT: 'Cuentas',
	EVENT: 'Eventos',
	ANNOUNCEMENT: 'Anuncios',
};

export interface IAuditLog {
	id: number;
	accion: string;
	actorName: string;
	actorAvatarUrl: string | null;
	rol: EUserRole;
	fecha: Date;
	entidad: EAuditEntity;
	detail: string | null;
}

interface AuditLogResponse {
	id: number;
	action: string;
	actorId: number;
	actorName: string;
	actorAvatarUrl: string | null;
	actorRole: EUserRole;
	entity: EAuditEntity;
	entityId: number | null;
	detail: string | null;
	createdAt: string;
}

export const AUDIT_PAGE_SIZE = 20;

export interface AuditListQuery {
	entity?: EAuditEntity | 'all';
	role?: EUserRole | 'all';
	search?: string;
	dateRange?: string;
	page?: number;
	pageSize?: number;
}

export interface AuditLogPage {
	items: IAuditLog[];
	total: number;
}

interface AuditLogPageResponse {
	items: AuditLogResponse[];
	total: number;
}

const toAuditLog = (row: AuditLogResponse): IAuditLog => ({
	id: row.id,
	accion: row.action,
	actorName: row.actorName,
	actorAvatarUrl: row.actorAvatarUrl,
	rol: row.actorRole,
	fecha: new Date(row.createdAt),
	entidad: row.entity,
	detail: row.detail,
});

export const listAuditLogs = (query: AuditListQuery = {}): Promise<AuditLogPage> => {
	const path = `/api/audit-logs${queryString({
		entity: query.entity && query.entity !== 'all' ? query.entity : undefined,
		role: query.role && query.role !== 'all' ? query.role : undefined,
		search: query.search?.trim() || undefined,
		page: query.page,
		pageSize: query.pageSize ?? AUDIT_PAGE_SIZE,
		...(query.dateRange ? dateRangeParams(query.dateRange) : {}),
	})}`;
	return request<AuditLogPageResponse>(path).then((page) => ({
		items: page.items.map(toAuditLog),
		total: page.total,
	}));
};
